import React from 'react';
import { Icon, List, Popup } from 'semantic-ui-react';

import { Telefonos } from './tipos';

export const OtrosTelefonos = (props: { telefonos: Telefonos }) => {
    const { telefonos } = props;
    if (!telefonos.fijo && (!telefonos.otros || telefonos.otros.length === 0)) return null;

    return (
        <Popup
            trigger={
                <span style={{ marginLeft: '10px' }}>
                    <Icon name='ellipsis horizontal' />
                </span>
            }
            hideOnScroll
            hoverable
        >
            <Popup.Header>Otros teléfonos</Popup.Header>
            <Popup.Content>
                <List>
                    {telefonos.fijo && (
                        <List.Item>
                            Fijo: <b>{`2 ${telefonos.fijo}`}</b>
                        </List.Item>
                    )}
                    {telefonos.otros &&
                        telefonos.otros.map((telefono, i) => (
                            <List.Item key={i}>
                                {telefono.nombre + ': '}{' '}
                                <b>{telefono.codArea + ' ' + telefono.numero}</b>
                            </List.Item>
                        ))}
                </List>
            </Popup.Content>
        </Popup>
    );
};



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/ListaGeneral/OtrosTelefonos.tsx